"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/CallForwardingTab/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _noticeBar = require('web/services/context/noticeBar');
var _CallForwardingSection = require('./CallForwardingSection'); var _CallForwardingSection2 = _interopRequireDefault(_CallForwardingSection);








const CallForwardingTab = ({
  phoneNumber,
  forwardingNumber,
  onSaveForwardingNumber,
  onClearForwardingNumber,
}) => {
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [saveForwardingNumber, clearForwardingNumber] = _react.useMemo.call(void 0, 
    () => [
      async (phoneValue) => onSaveForwardingNumber(phoneValue)
        .then(() => showSuccessBar('Call forwarding number has been updated'))
        .catch(() => showWarningBar('Failed to update call forwarding number')),
      async () => onClearForwardingNumber()
        .then(() => {
          showSuccessBar('Call forwarding has been disabled')
          return true
        })
        .catch(() => {
          showWarningBar('Failed to disable call forwarding')
          return false
        }),
    ],
    [onSaveForwardingNumber, onClearForwardingNumber, showSuccessBar, showWarningBar],
  )

  return (
    _react2.default.createElement(_CallForwardingSection2.default, {
      phoneNumber: phoneNumber,
      forwardingNumber: forwardingNumber,
      onSave: saveForwardingNumber,
      onClear: clearForwardingNumber, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
    )
  )
}

exports. default = CallForwardingTab
